/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const SpinnerIcon: React.SFC = () => {
    return (
        <svg width="34" height="37" viewBox="0 0 42 45" xmlns="http://www.w3.org/2000/svg">
            <circle cx="21" cy="10" r="5" fill="#FcA61B" fillRule="evenodd" />
        </svg>

    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Spinner/Spinner.tsx